"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderPriceToDisplay = void 0;
var _numberFormatter = require("./numberFormatter");
var getOrderPriceToDisplay = exports.getOrderPriceToDisplay = function getOrderPriceToDisplay(order, decimalPlaces) {
  return order.trailingPrice ? order.trailingPrice : order.Price ? (0, _numberFormatter.formatNumberToLocale)(order.Price, decimalPlaces || order.Price.symbol) : '';
};